import './bolero/style';
import FormStructure from './bolero/form_structure';

export default FormStructure;